import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent {
  @Input() icon!: string;
  @HostBinding('style.--alert-text-width') @Input() textWidth!: string;
}
